<app-loading-spinner [show]="loading"></app-loading-spinner>

<form [formGroup]="serviceAreaFormGroup">
  <div class="row">
    <div class="col">
      <h2>New Loan Application</h2>
      <p>We provide loans between $1,000 and $10,000.</p>

      <p class="h1 color-primary mb-4">Get Started!</p>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="mb-3">
            <label class="form-label" for="zipCode">
              Enter your Zip Code
              <span *ngIf="controlIsRequired('RequestZip')" class="color-error"
                >*</span
              >
            </label>
            <input
              class="form-control"
              id="zipCode"
              placeholder="Zip code"
              type="text"
              formControlName="RequestZip"
              aria-label="Applicants zip code"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="mb-3">
            <label class="form-label" for="requestAmount">
              Request Amount
              <span
                *ngIf="controlIsRequired('RequestAmount')"
                class="color-error"
                >*</span
              >
            </label>
            <div class="input-group mb-3">
              <span class="input-group-text">$</span>
              <input
                class="form-control"
                id="requestAmount"
                placeholder="Amount"
                type="number"
                min="1000"
                max="10000"
                step="100"
                formControlName="RequestAmount"
                aria-label="Amount (to the nearest dollar)"
              />
            </div>
          </div>
        </div>
      </div>

      <app-request-purpose-info
        [controls]="serviceAreaFormGroup.controls"
        label="Purpose of Loan"
      ></app-request-purpose-info>

      <app-application-type-info
        [controls]="serviceAreaFormGroup.controls"
        (changeEvent)="onChangeEvent($event)"
      ></app-application-type-info>

      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <label class="form-label" for="requestReferral">
            How did you hear about us?
            <span
              *ngIf="controlIsRequired('RequestReferCD')"
              class="color-error"
              >*</span
            >
          </label>

          <select
            id="requestReferral"
            class="form-select"
            aria-label="Referral type dropdown menu."
            formControlName="RequestReferCD"
          >
            <option selected value="">Select referral type.</option>
            <option *ngFor="let item of referralTypes" [value]="item.Value">
              {{ item.Text }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="col">
    <div class="my-5">
      <button
        [disabled]="loading"
        type="button"
        (click)="onApplyNow()"
        class="btn btn-primary"
      >
        Apply Now
        <i class="bi bi-chevron-right"></i>
      </button>

      <app-validation-text
        [show]="isDirtyAndMissingRequiredFields"
      ></app-validation-text>
    </div>
  </div>
</div>
